import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-check-box-freeform',
    templateUrl: './check-box-freeform.component.html',
    styleUrls: ['./check-box-freeform.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckboxFreeformComponent {
  @Input() helpText: string;
  // @Input() errorMessage: string;
  @Input() caption: string;
  @Input() initialValue: boolean = false;

  @Output() checkboxChange: EventEmitter<boolean> = new EventEmitter();

  onCheckboxChange(event: any): void {
    this.checkboxChange.emit(event.checked);
  }
}
